import { render, staticRenderFns } from "./compress.vue?vue&type=template&id=fd72ad2a&scoped=true"
import script from "./compress.vue?vue&type=script&lang=js"
export * from "./compress.vue?vue&type=script&lang=js"
import style0 from "./compress.vue?vue&type=style&index=0&id=fd72ad2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd72ad2a",
  null
  
)

export default component.exports